import { __param } from "tslib";
import { GQLQuerySpec, queryType } from "../core.utilidades/graphql-utils";
import { TokenOperacion } from "../app.domain.models/token-operacion";

const type = TokenOperacion;
const typeName = 'TokenOperacion'

export const TokenOperacionQuery = {
    paramType: typeName,

    obtenerById: new GQLQuerySpec({
        queryType: queryType.QUERY,
        methodName: 'obtener' + typeName + 'ById',
        fields: type.getFields(),

    }),

    crear: new GQLQuerySpec({
        queryType: queryType.MUTATION,
        methodName: 'crear' + typeName,
        fields: type.getFields(),
    }),
    
    generarTokenFirma: new GQLQuerySpec({
        queryType: queryType.PERSONALIZADA,
        queryPersonalizada: 'mutation m($instancia: DatosFirmaOperacionInput) { content: generarTokenFirma(instancia: $instancia) }'
    }), 

}
